module.exports = __webpack_public_path__ + "53b86c19fa4e9bab2028bc18ec6f4523.pdf";